import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";

export default class Individual extends Model{
    /* Follow the namespace in the backend */
    static entity = 'Household\\Model\\Individual';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            gender: this.attr(''),
            current_age: this.number(null),
            retirement_age: this.number(null),
            will_die_at: this.number(null),
            profession: this.attr(null),
            role: this.attr(null),
            le_strategy: this.attr(null),
            birth_date: this.attr(null),
            birth_date_verified: this.attr(null),
            household_id: this.number(null),
            beneficiaryAssignmentsAsAssigned: this.morphMany(BeneficiaryAssignment, 'assigned_id', 'assigned_type'),
        }
    }

    get displayName() {
        return this.name;
    }

    get type() {
        return 'Household\\Model\\Individual';
    }
}
